import debounce from 'lodash.debounce';
import { useMemo, useEffect } from 'react';
function isDependencyList(deps) {
    return deps !== null && deps !== undefined && Array.isArray(deps);
}
function isNumber(value) {
    return typeof value === 'number';
}
export function useDebounce(fn, waitOrSettingsOrDeps, deps = []) {
    const { wait, ...options } = (!isNumber(waitOrSettingsOrDeps) && !isDependencyList(waitOrSettingsOrDeps)) ? waitOrSettingsOrDeps : {
        wait: isNumber(waitOrSettingsOrDeps) ? waitOrSettingsOrDeps : 0,
    };
    const debounced = useMemo(() => debounce(fn, wait, options), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [wait, options.leading, options.trailing, options.maxWait, ...(isDependencyList(waitOrSettingsOrDeps) ? waitOrSettingsOrDeps : []), ...deps]);
    // cancel all pending invocations when memo updates or hook is unmounted
    useEffect(() => () => debounced.cancel(), [debounced]);
    return debounced;
}
//# sourceMappingURL=useDebounce.js.map